import request from 'utils/request';

type Group = {
  id: string;
  team_id: string;
  name: string;
  type: string;
  numMembers: number;
};

type Owner = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role_id: string;
};

type User = {};

export type UserPermissonResponse = {
  status: 'success' | 'fail';
  permissions: {
    users: User[]; // It is not used in the E1
    groups: Group[];
    owner: Owner;
  };
};

/**
 * Fetcher to get the workspace teams list
 * @returns {TeamsResponse}
 */
export const getInfograhpicUsers = async (e1InfographId: string) => {
  return await request<UserPermissonResponse>(`/permissionsmanager/get_infographic_users/${e1InfographId}`, {
    method: 'GET',
  });
};

/**
 * Grant the group share permission for the infograph
 * @param e1InfographId {string}
 * @param teamId {string}
 * @returns {UserPermissonResponse}
 */
export const grantGroupInfographicPermission = async (e1InfographId: string, teamId: string) => {
  return await request<UserPermissonResponse>(
    `/permissionsmanager/grant_group_infographic_permission/${teamId}/${e1InfographId}/editor?from=Editor`,
    {
      method: 'GET',
    },
  );
};

/**
 * Revoke the group share permission for the infograph
 * @param e1InfographId {string}
 * @param teamId {string}
 * @returns {UserPermissonResponse}
 */
export const revokeGroupInfographicPermission = async (e1InfographId: string, teamId: string) => {
  return await request<UserPermissonResponse>(
    `/permissionsmanager/revoke_group_infographic_permission/${teamId}/${e1InfographId}`,
    {
      method: 'GET',
    },
  );
};
